
import $axios from '@/plugins/axiosInstance'

// import axios from 'axios';

// axios.defaults.withCredentials = true;

export default {
 
    
              listYoneticiler() {
      return $axios.get('Yonetici');
    },
                  insert(yonetici) {
      return $axios.post('Yonetici',yonetici);
    },
     update(id,yonetici) {
      return $axios.put('Yonetici/'+id,yonetici);
    },
     delete(id) {
      return $axios.delete('Yonetici/'+id);
    },

 
  };